import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { FiLogOut, FiMenu, FiX } from "react-icons/fi";
import Logo from "components/Logo";
import { signOut as signOutAction } from "../../redux/user/user.actions";

import "./header.scss";
import { useDispatch } from "react-redux";

export function Header({ userRole, onToggleSidebar, sidebarCollapsed }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signOutAdmin = () => {
    // Clear tokens and Redux state (signOut action handles both)
    dispatch(signOutAction());
    // Navigate to login page
    navigate("/", { replace: true });
  };

  return (
    <Navbar
      className="modern-header"
      collapseOnSelect
      expand="lg"
      fixed="top"
      variant="light"
    >
      <button
        onClick={onToggleSidebar}
        className="header-sidebar-toggle"
        aria-label="Toggle sidebar"
      >
        {sidebarCollapsed ? <FiMenu /> : <FiX />}
      </button>
      <Navbar.Brand as={Link} to="/" className="header-logo">
        <Logo
          height="40px"
          style={{
            height: "40px",
            width: "110px",
          }}
        />
      </Navbar.Brand>
      <Navbar.Toggle
        aria-controls="responsive-navbar-nav"
        className="header-toggle"
      />
      <Navbar.Collapse id="responsive-navbar-nav" className="header-nav">
        <Nav className="ms-auto">
          <button onClick={signOutAdmin} className="header-signout-btn">
            <FiLogOut className="signout-icon" />
            <span>Sign Out</span>
          </button>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}
